import React from "react";

const LoadErrorPlaceholder = ({ title = "Unable to load data" }) => {
  return (
    <div className="flex flex-col justify-center items-center px-4 py-12">
      <svg
        className="mb-4 w-48 h-48"
        viewBox="0 0 400 300"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Decorative Background */}
        <circle cx="200" cy="150" r="120" fill="#f3f4f6" />
        
        {/* Shopping Bag */}
        <path
          d="M160 100h80v100h-80z"
          fill="#FF6C6C"
          opacity="0.2"
        />
        <path
          d="M150 100c0-27.614 22.386-50 50-50s50 22.386 50 50"
          stroke="#FF6C6C"
          strokeWidth="8"
          strokeLinecap="round"
        />
        
        {/* Price Tag */}
        <path
          d="M180 130l40 40M220 130l-40 40"
          stroke="#FF6C6C"
          strokeWidth="8"
          strokeLinecap="round"
        />
        
        {/* Animated Elements */}
        <circle
          cx="200"
          cy="150"
          r="5"
          fill="#FF6C6C"
          className="animate-ping"
        />
        
        {/* Decorative Dots */}
        <circle cx="160" cy="90" r="4" fill="#FF6C6C" opacity="0.5" />
        <circle cx="240" cy="90" r="4" fill="#FF6C6C" opacity="0.5" />
        <circle cx="200" cy="210" r="4" fill="#FF6C6C" opacity="0.5" />
      </svg>
      <h3 className="mb-1 text-xl font-semibold text-gray-900">{title}</h3>
      <p className="max-w-sm text-center text-gray-500">
        Check check your connection and try again!
      </p>
    </div>
  );
};

export default LoadErrorPlaceholder;